module.exports = __webpack_public_path__ + "ad7bb9fa9168d131f09ea13ca084c406.svg";


//////////////////
// WEBPACK FOOTER
// ./images/credit/late-60-symbol.svg
// module id = 91
// module chunks = 0